<template>
  <span>
    <span :style="`background-color: ${object.deposit_account.color}`"
          class="circle sm mr-1"></span>
    {{ object.deposit_account.title }}
  </span>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  }
})
</script>
